import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, POST, Body, GET, Adapter } from '@royalty/httpclient';
import { LoginData } from '@royalty/authentication/login';

@Injectable()
export class AuthService extends HttpService {

	public isLoggedIn: boolean = false;
	public returnUrl: string = null;

	@POST('auth/login')
	@Adapter(null, { isAuthorize: true })
	login(@Body data: LoginData): Observable<any> {
		return null;
	}

	@GET('auth/logout')
	logout(): Observable<any> {
		return null;
	}
}
